import moment from 'moment';

import callApi from '../../util/apiCaller.js';
import { slugify } from '../../util/text.js';

import { getTranslation } from '../Intl/IntlHelper.js';
import { addError } from '../Error/ErrorActions.js';
import { formatPrice } from '../../util/price.js';

// Export Constants
export const SET_PRODUCTS = 'SET_PRODUCTS';

// Export Actions

export function getProductsRequest(isAll = false) {
    return dispatch => {
        return callApi(`products${isAll ? '/all' : ''}`).then(res => {
            if(res.products) {
                dispatch(setProducts(res.products));
            }
            return res.products;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editProductRequest(product, fetchAll = true) {
    return dispatch => {
        return callApi('product/edit', 'post', { product }).then(res => {
            if(res.product) {
                fetchAll && dispatch(getProductsRequest(true));
            }
            return res.product;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getFilteredProducts(products, filters = { isActive: null, isVariation: null }) {
    // console.log('getFilteredProducts', filters);
    Object.keys(filters || {}).forEach(key => {
        if(filters[key] !== null) {
            products = products.filter(product => {
                // product[key] !== 'undefined' && product[key] !== filters[key] && console.log('Prorduct::: get from store::: Exclude', product, key, filters[key]);
                return typeof product[key] === 'undefined' || product[key] === filters[key];
            });
        }
    });
    // console.log('products filtered', products);
    return products;
}

export function getProducts(store, filters = {}) {
    return getFilteredProducts(store.products.data, filters);
}

export function getProduct(store, productId) {
    return store.products.data.find(product => product._id === productId);
}

export function getProductBySlug(store, productSlug, lang = null) {
    return store.products.data.find(product => {
        return getProductSlug(product, lang || store.intl.locale) === (productSlug && productSlug.toLowerCase());
    });
}

export function getProductSlug(product, lang) {
    return (getTranslation(product, 'slug', lang) && getTranslation(product, 'slug', lang).toLowerCase()) || slugify(getTranslation(product, 'name', lang)).toLowerCase();
}

export function getProductsAttributeList(store, attributeName, lang = null) {
    let attributes = [];
    getProducts(store).forEach(product => {
        const productAttributes = getProductAttributeList(product, attributeName, lang || store.intl.locale);
        if(productAttributes) {
            attributes = attributes.concat(productAttributes);
        }
    });
    return attributes.filter((attribute, index, self) => self.indexOf(attribute) === index) || [];
}

export function getProductAttributeList(product, attributeName, lang) {
    return getTranslation(product, attributeName, lang) || [];
}

export function getProductPrice(product, quantity = 1, inclTax = true, referral = null) {
    let price = 0;
    const specialPrice = getProductSpecialPrice(product, 'priceTTC', quantity, referral);
	// inclTax && console.log('getProductPrice', { product, specialPrice, value: specialPrice && getProductSpecialPriceValue(product, specialPrice, quantity || 1) });
    if(product) {
        price = parseFloat(specialPrice ? getProductSpecialPriceValue(product, specialPrice, quantity || 1) : (product.priceTTC * (quantity || 1)));
    }
    if(!inclTax) {
        price /= (1 + parseFloat(product.taxRate));
    }
    return price;
}

export function getProductSpecialPrices(product, key = 'priceTTC', quantity = null, referral = null) {
	return ((product || {}).specialPrices || []).filter(specialPrice => filterProductSpecialPrice(specialPrice, key, quantity, referral));
}

export function getProductSpecialPrice(product, key = 'priceTTC', quantity = null, referral = null) {
    // console.log('getProductSpecialPrice', (product || {}).specialPrices, key, referral);
    return ((product || {}).specialPrices || []).sort((spA, spB) => (spA.quantity || 0) - (spB.quantity || 0)).find(specialPrice => filterProductSpecialPrice(specialPrice, key, quantity, referral)) || (referral && getProductSpecialPrice(product, key, quantity)) || null;
}

export function filterProductSpecialPrice(specialPrice, key, quantity = null, referral = null) {
	// console.log(specialPrice);
	// console.log('key', specialPrice.key === key);
	// console.log('quantity', !specialPrice.quantity, parseInt(quantity || 1, 10) <= 1, parseInt(quantity, 10), parseInt(specialPrice.quantity || 0, 10));
	// console.log('referral', (!specialPrice.referral || specialPrice.referral === referral));
	// console.log('dateThreshold', (!specialPrice.dateThreshold || moment.utc().isSameOrBefore(getProductSpecialPriceDateThreshold(specialPrice))));
	return (
		specialPrice.key === key
		&& (!specialPrice.referral || specialPrice.referral === referral)
		&& (!specialPrice.dateThreshold || moment.utc().isSameOrBefore(getProductSpecialPriceDateThreshold(specialPrice)))
		&& (quantity === null || !specialPrice.quantity || parseInt(quantity, 10) >= parseInt(specialPrice.quantity || 0, 10))
	);
}

export function getProductSpecialPriceValue(product, specialPrice, quantity = 1) {
	const basePrice = parseFloat(product.priceTTC) * quantity;
    return specialPrice.value.includes('%') ? ((parseFloat(specialPrice.value) * basePrice) / 100) : specialPrice.value;
}

export function getProductSpecialPriceDateThreshold(specialPrice) {
	if(specialPrice?.dateThreshold) {
		let date = moment.utc(specialPrice.dateThreshold);

		// Add X days to now
		if(specialPrice.dateThreshold.includes('+')) {
			// console.log(`date threshold +${parseInt(specialPrice.dateThreshold, 10)} Jours`);
			date = moment.utc().add(parseInt(specialPrice.dateThreshold, 10), 'days');

		// Set next date to next day of month (for value of 8 => date is next 8th of the month)
		} else if(!specialPrice.dateThreshold.includes('/')) {
			let diffDays = parseInt(specialPrice.dateThreshold - moment.utc().format('D'), 10);
			if(diffDays < 0) {
				diffDays = 31 + diffDays;
			}
			date = moment.utc().add(diffDays, 'days');
		}
		// console.log('date threshold', specialPrice.dateThreshold, dateFormat(date, 'LL'));
		return date.endOf('day');
	}
	return null;
}

export function getProductBooksDiscountRate(product, books = [], referral = '') {
	let discountPercent = null;
	(getProductOption(product, 'bookPrices') || []).forEach(bookPrice => {
		if(books.length >= bookPrice.count) {
			discountPercent = 100
				- (
					bookPrice.value.includes('%')
					? parseFloat(bookPrice.value)
					: (100
						- (
							(parseFloat(bookPrice.value) * 100)
							/ getProductPrice(product, 1, true, referral)
						)
					)
				);
		}
	});
	return discountPercent;
	// if(this.props.bookDiscounts) {
	//     const booksCount = this.getSelectedBooks('book').length;
	//     const rules = this.props.bookDiscounts.split('/').map(ruleString => {
	//         const [min, rate] = ruleString.split(':');
	//         return {
	//             min,
	//             rate,
	//         };
	//     }).sort((ruleA, ruleB) => ruleB.min - ruleA.min);

	//     const { min, rate } = rules.find(rule => rule.min <= booksCount) || {};

	//     return rate;
	// }
	// return null;
}

export function getProductOption(product, option) {
    return (product && product.options && product.options[option]) || '';
}

export function setProducts(products) {
    return {
        type: SET_PRODUCTS,
        products,
    };
}
